import { Anchor } from '@mantine/core'
import type { Reference, Resource } from '@medplum/fhirtypes'
import { generateMedplumAppLink } from '@seen/core/utilsExtendedResource'
import type { JSX, ReactNode } from 'react'

export function MedplumAppLink(props: {
  to?: Resource | Reference
  children: ReactNode
  pathSuffix?: string
}): JSX.Element {
  if (!props.to) {
    return <>{props.children}</>
  }

  return (
    <Anchor
      href={generateMedplumAppLink(props.to, props.pathSuffix)}
      target="_blank"
    >
      {props.children}
    </Anchor>
  )
}
